/**
 * @generated SignedSource<<410106da5b87795232ab8e45724375d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventModal_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsSubmissionAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TitleBarWithAction_resource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubscribeToEventButton_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetails_participativeModule"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

node.hash = "713e45539fb18acf1689016cedee54b0";

module.exports = node;
